module.exports = __webpack_public_path__ + "img/127.4e6fcbca.jpg";